"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";

/**
 * @module UserScriptWeakError
 * @requires UserScriptWeakError
 * @exports UserScriptWeakError
 */

/**
 * Uses in user defined scripts. Closes the form edit.
 * @example
 * async OnChangeQty(model) {
 *      let QtyFldValue = model.getFieldByName(SQty).value();
 *
 *      if (QtyFldValue === 100) throw new window.UserScriptWeakError();
 *      return model;
 *  };
 *
 */
var UserScriptWeakError =
/*#__PURE__*/
function (_Error) {
  _inherits(UserScriptWeakError, _Error);

  function UserScriptWeakError() {
    var _this;

    _classCallCheck(this, UserScriptWeakError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserScriptWeakError).call(this));
    _this.name = _this.constructor.name;

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), _this.constructor);
    } else {
      _this.stack = new Error().stack;
    }

    return _this;
  }

  return UserScriptWeakError;
}(_wrapNativeSuper(Error));

export { UserScriptWeakError as default };